import { Field, Model } from 'serialize-ts';
import { BestOffer } from './best-offer.model';

@Model()
export class CheapestOffer {
  @Field()
  b2b: BestOffer;

  @Field()
  b2c: BestOffer;
}
